import { getAppealStatusValues, getEnumValues } from 'features/claims/claimsApi'
import { useEffect, useMemo } from 'react'
import useSWRImmutable from 'swr/immutable'
import type { AppealEnumDescriptions } from 'utils/dataExtractor'

const getDescriptions = (values: { value: number; description: string }[] | undefined) =>
  Object.fromEntries(values?.map(({ value, description }) => [String(value), description]) ?? [])

export const useAppealEnumDescriptions = (): AppealEnumDescriptions => {
  const { data: appealStatuses, error: appealStatusesError } = useSWRImmutable(
    'enum/AppealStatus/values',
    getAppealStatusValues,
  )
  const { data: appealSubmissionMethods, error: appealSubmissionMethodsError } = useSWRImmutable(
    'enum/AppealSubmissionMethod/values',
    () => getEnumValues('AppealSubmissionMethod'),
  )
  const { data: levelsOfAppeal, error: levelsOfAppealError } = useSWRImmutable('enum/LevelOfAppeal/values', () =>
    getEnumValues('LevelOfAppeal'),
  )

  useEffect(() => {
    if (appealStatusesError) console.error('Error loading appeal status:', appealStatusesError)
    if (appealSubmissionMethodsError) {
      console.error('Error loading appeal submission methods:', appealSubmissionMethodsError)
    }
    if (levelsOfAppealError) console.error('Error loading levels of appeal:', levelsOfAppealError)
  }, [appealStatusesError, appealSubmissionMethodsError, levelsOfAppealError])

  return useMemo(
    () => ({
      appeal_status: getDescriptions(appealStatuses),
      appeal_submission_method: getDescriptions(appealSubmissionMethods),
      level_of_appeal: getDescriptions(levelsOfAppeal),
    }),
    [appealStatuses, appealSubmissionMethods, levelsOfAppeal],
  )
}
